export const APEX_API_URL = 'https://staging-api.apexbd.link';
export const APEX_MAIL_CHIMP_URL =
  'https://asthait.us9.list-manage.com/subscribe/post?u=c3787978f1467382bd0f28b67&amp;id=a1578b32ac&amp;f_id=005c22e1f0';
